import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";

export const DOCUMENTS_DESCRIPTION = "Access reports, meeting notes, and files shared by your consultant.";

export const HomeSharedDocuments: React.FunctionComponent = () => {
    const navigate = useNavigate();

    return (
        <div
            className="home__resource-card"
            onClick={() => navigateTo("/shared-documents", navigate)}
            data-testid="home-shared-documents__container"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    navigateTo("/shared-documents", navigate);
                }
            }}
        >
            <div className="home__resource-card-header">
                <div className="home__resource-card-icon home__resource-card-icon--documents">
                    <i className="fa-light fa-file-lines" />
                </div>
                <h3 className="home__resource-card-title">
                    {getTranslation("header.shared-documents", "Shared Documents")}
                </h3>
            </div>
            <p className="home__resource-card-description">
                {getTranslation("home.shared-documents.description", DOCUMENTS_DESCRIPTION)}
            </p>
        </div>
    );
};
